import React, { Component } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import PropTypes from 'prop-types';
import rankedTagImg from '../../../assets/images/icons/ranked_tag.svg';
import './TagDisplay.scss';

const rankedTagTooltip = (ranking = null, location = null, mustHave = null) => (
  <Tooltip className="proficiency-ranking-tag-tooltip" id="proficiency-ranking-tooltip">
    <ul className="unindented-list">
      {ranking && (
      <li>
        {' '}
        {ranking ? 'Marked as top area by consultant' : ''}
        {' '}
      </li>
      )}
      {location !== 'search'
        && <li>Matches project requirements</li>}
      {mustHave && <li>Matches project must-have</li>}
    </ul>
  </Tooltip>
);

const matchingTags = (matchingFrom, matchingAgainst, complex) => (
  matchingFrom.filter((t) => matchingAgainst.includes(complex ? t.name : t))
);

class TagDisplay extends Component {
  constructor(props) {
    super(props);
    const { areRoles } = this.props;
    this.state = {
      roleTags: areRoles,
    };

    this.renderRoleTags = this.renderRoleTags.bind(this);
    this.renderTagsSearch = this.renderTagsSearch.bind(this);
    this.renderSingleTag = this.renderSingleTag.bind(this);
    this.renderRecommendationTags = this.renderRecommendationTags.bind(this);
  }

  renderRoleTags() {
    const { consultant } = this.props;
    if (consultant.higher_level_roles.length > 0) {
      return (
        <div id="role-tag-group" className="tags role-tags">
          <div id="roles-group" className="tag-group">
            {consultant.higher_level_roles.map((t) => (
              <span id="role-tag" key={t.name} className="badge medium me-2">
                {t.name.length > 40 ? `${t.name.substring(0, 40)}...` : t.name}
                <span className="experience">
                  {t.experience}
                </span>
              </span>
            ))}
          </div>
        </div>
      );
    }
    return null;
  }

  renderTagsSearch(header, tags) {
    const { location } = this.props;
    if (tags.length > 0) {
      return (
        <div className="tag-group">
          <h4 className="medium-weight regular-spacing">{header}</h4>
          {tags.map((t) => (
            t.ranking
              ? (
                <OverlayTrigger placement="top" overlay={rankedTagTooltip(t.ranking, location, false)}>
                  <span key={t} className="badge small me-2">
                    {t.ranking
                  && (
                  <img
                    className="me-3"
                    src={rankedTagImg}
                    alt="Top Tag"
                    height="14"
                    width="10"
                  />
                  )}
                    {t.name ? t.name : t}
                    <span className="experience">
                      {t.experience}
                    </span>
                  </span>
                </OverlayTrigger>
              )
              : (
                <span key={t} className="badge small me-2">
                  {t.name ? t.name : t}
                  <span className="experience">
                    {t.experience}
                  </span>
                </span>
              )
          ))}
        </div>
      );
    }
    return null;
  }

  renderSingleTag(tag, rank, experience) {
    const { location, priorityTags, seniorityTags } = this.props;
    const isPriority = priorityTags.includes(tag);
    const mustHave = seniorityTags.includes(tag) || isPriority;
    return (
      <OverlayTrigger placement="top" overlay={rankedTagTooltip(rank, location, isPriority)}>
        <span
          id="recommendation-tag"
          key={tag}
          className={`badge small ${rank ? 'proficiency ' : ''} ${mustHave ? 'purple-base ' : ''}  me-2`}
        >
          {rank
            && (
            <img
              className={`me-3 ${mustHave ? 'white-icon' : ''}`}
              src={rankedTagImg}
              alt="Top Tag"
              height="14"
              width="10"
            />
            )}
          {tag}
          <span id="years" className={`experience ${mustHave ? 'highlighted ' : ''}`}>
            {experience}
          </span>
        </span>
      </OverlayTrigger>
    );
  }

  renderRecommendationTags() {
    const {
      consultant, seniorityTags, priorityTags, nonPriorityTags,
    } = this.props;
    const projectTags = [...priorityTags, ...nonPriorityTags];

    const matchedSeniorities = matchingTags(consultant.seniority_levels, seniorityTags, false);
    const matchedExpertise = matchingTags(consultant.area_of_expertises, projectTags, true);
    const matchedTherapeuticAreas = matchingTags(consultant.therapeutic_areas, projectTags, true);
    const matchedTherapies = matchingTags(consultant.therapies, projectTags, true);
    const matchedDiseases = matchingTags(consultant.diseases, projectTags, true);
    const matchedPhases = matchingTags(consultant.development_phases, projectTags, false);
    return (
      <div id="recommendation-tags" className="tag-group">

        {matchedSeniorities.map((t) => (
          this.renderSingleTag(t, false, '')
        ))}

        {matchedExpertise.map((t) => (
          this.renderSingleTag(t.name, false, t.experience)
        ))}

        {matchedTherapeuticAreas.map((t) => (
          this.renderSingleTag(t.name, t.ranking, t.experience)
        ))}

        {matchedTherapies.map((t) => (
          this.renderSingleTag(t.name, t.ranking, t.experience)
        ))}

        {matchedDiseases.map((t) => (
          this.renderSingleTag(t.name, t.ranking, t.experience)
        ))}

        {matchedPhases.map((t) => (
          this.renderSingleTag(t, false, '')
        ))}
      </div>
    );
  }

  render() {
    const { location, consultant } = this.props;
    const { roleTags } = this.state;

    if (roleTags) {
      return (
        this.renderRoleTags()
      );
    }

    return (
      <div>
        {location === 'search'
          && (
          <div id="recommendation-tag-group" className="tags">
            {this.renderTagsSearch('Therapeutic areas', consultant.therapeutic_areas)}
            {this.renderTagsSearch('Product Technologies', consultant.therapies)}
            {(consultant.therapeutic_areas.length === 0 || consultant.therapies.length === 0)
              && this.renderTagsSearch('Phases of development', consultant.development_phases)}
          </div>
          )}

        {location !== 'search'
          && (
          <div className="tags">
            {this.renderRecommendationTags()}
          </div>
          )}
      </div>
    );
  }
}

TagDisplay.propTypes = {
  consultant: PropTypes.shape({}).isRequired,
  location: PropTypes.string,
  seniorityTags: PropTypes.arrayOf(PropTypes.string),
  priorityTags: PropTypes.arrayOf(PropTypes.string),
  nonPriorityTags: PropTypes.arrayOf(PropTypes.string),
  areRoles: PropTypes.bool,
};

TagDisplay.defaultProps = {
  location: '',
  areRoles: false,
};

export default TagDisplay;
